







































import Cropper from "cropperjs";
import { Debounce } from "vue-debounce-decorator";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import "cropperjs/dist/cropper.css";
import { required } from "@/shared/validators";

@Component
export default class ImageCropper extends Vue {
  @Prop() value!: string;
  @Prop() imagemUrl!: string;
  @Prop({ default: null }) readonly aspectRatio!: number | null;

  cropper: null | Cropper = null;
  objectUrl = "";
  previewCropped = "";
  selectedFile: null | File = null;

  rules = {
    selectedFile: [required()],
  };

  @Watch("aspectRatio")
  onAspectRatioChange(val: number | null) {
    if (this.cropper) {
      this.cropper.setAspectRatio(val ?? 0);
    }
  }

  mounted() {
    if (this.imagemUrl) {
      this.imageReference();
    }
  }

  imageReference() {
    if (this.imagemUrl.indexOf("null") == -1) {
      this.objectUrl = this.imagemUrl;
      this.previewCropped = this.imagemUrl;
    }
  }

  resetCropper() {
    if (this.cropper) {
      this.cropper.reset();
    }
  }
  rotateLeft() {
    if (this.cropper) {
      this.cropper.rotate(-90);
    }
  }
  rotateRight() {
    if (this.cropper) {
      this.cropper.rotate(90);
    }
  }
  setupCropper() {
    if (this.cropper) {
      if (this.cropper.destroy) {
        this.cropper.destroy();
      }
    }

    if (this.objectUrl) {
      window.URL.revokeObjectURL(this.objectUrl);
    }

    if (!this.selectedFile) {
      this.cropper = {} as Cropper;
      this.objectUrl = "";
      this.previewCropped = "";
      return;
    }

    this.objectUrl = window.URL.createObjectURL(this.selectedFile);
    this.$nextTick(this.setupCropperInstance);
  }
  setupCropperInstance() {
    this.cropper = new Cropper(this.$refs.source as HTMLCanvasElement, {
      aspectRatio: this.aspectRatio ?? undefined,
      crop: this.updatePreview,
    });
  }
  @Debounce(256)
  updatePreview() {
    if (this.cropper) {
      const canvas = this.cropper.getCroppedCanvas();
      const ctx = canvas.getContext("2d");
      if (ctx) {
        const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imgData.data;
        for (let i = 0; i < data.length; i += 4) {
          if (data[i + 3] < 255) {
            data[i] = 255;
            data[i + 1] = 255;
            data[i + 2] = 255;
            data[i + 3] = 255;
          }
        }
        ctx.putImageData(imgData, 0, 0);
      }

      this.previewCropped = canvas.toDataURL("image/jpeg");
      this.$emit("input", this.previewCropped);
    }
  }
}
